const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

const routeAliases = new Map([
    ["/execute-strategy", "/api/execution/execute-strategy"],
    ["/active-preset", "/api/execution/active-preset"],
    ["/pending-orders", "/api/execution/pending-orders"],
    ["/retry-queued", "/api/execution/retry-queued"],
    ["/cancel-order", "/api/execution/cancel-order"],
    ["/positions", "/api/positions/positions"],
]);

function resolveRouteAlias(path) {
    if (routeAliases.has(path)) {
        return routeAliases.get(path);
    }

    // Harden the positions automation path for production builds that may
    // already be passing an /api-prefixed route. The backend route lives at:
    //   /api/positions/positions/<id>/automation
    if (
        path.startsWith("/api/positions/") &&
        !path.startsWith("/api/positions/positions/")
    ) {
        return `/api/positions/positions/${path.slice("/api/positions/".length)}`;
    }

    for (const [aliasPrefix, targetPrefix] of routeAliases.entries()) {
        if (path.startsWith(`${aliasPrefix}/`)) {
            return `${targetPrefix}${path.slice(aliasPrefix.length)}`;
        }
    }

    return null;
}

function getBackendUrl() {
    if (typeof window === "undefined") {
        return configuredBackendUrl;
    }

    const hostname = window.location.hostname;
    const isLocalBrowser = hostname === "localhost" || hostname === "127.0.0.1";
    const localBackendUrl = "";
    const pointsToRemoteBackend =
        configuredBackendUrl.startsWith("http") &&
        !configuredBackendUrl.includes("localhost") &&
        !configuredBackendUrl.includes("127.0.0.1");

    // In local development, prefer the CRA dev proxy so cookies stay same-origin
    // even when the Flask app is bound to 127.0.0.1:5001.
    if (isLocalBrowser) {
        if (!configuredBackendUrl || pointsToRemoteBackend) {
            return localBackendUrl;
        }

        if (
            configuredBackendUrl.includes("localhost:5001") ||
            configuredBackendUrl.includes("127.0.0.1:5001")
        ) {
            return localBackendUrl;
        }

        return configuredBackendUrl;
    }

    return configuredBackendUrl;
}

export function buildApiUrl(path = "") {
    const aliasedPath = resolveRouteAlias(path);
    const normalizedPath = aliasedPath || (path.startsWith("/api") ? path : `/api${path}`);
    return `${getBackendUrl()}${normalizedPath}`;
}
